<template>
  <svg width="22" height="24" viewBox="0 0 22 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M20.7813 2.54999L18.9814 0.725006C18.8314 0.575006 18.6564 0.5 18.4564 0.5C18.2564 0.5 18.0563 0.575006 17.9313 0.725006L7.45636 11.35C7.38136 11.425 7.33134 11.5 7.28134 11.6L6.10635 14.575C6.00635 14.85 6.05634 15.175 6.28134 15.375C6.43134 15.525 6.60633 15.6 6.80633 15.6C6.90633 15.6 6.98136 15.575 7.08136 15.55L10.0313 14.375C10.1313 14.325 10.2063 14.275 10.2813 14.2L20.7563 3.57501C21.0813 3.30001 21.0813 2.82499 20.7813 2.54999ZM9.35635 13.05L8.15634 13.525L8.63135 12.3L18.4564 2.32501L19.2064 3.07501L9.35635 13.05ZM17.0063 12.15V22.25C17.0063 22.8 16.5064 23.25 15.9564 23.25H1.75635C1.20635 23.25 0.756348 22.8 0.756348 22.25V3.20001C0.756348 2.65001 1.20635 2.25 1.75635 2.25H12.1563C12.7063 2.25 13.1563 2.7 13.1563 3.25C13.1563 3.8 12.7063 4.25 12.1563 4.25H2.75635V21.25H15.0063V12.15C15.0063 11.6 15.4563 11.15 16.0063 11.15C16.5563 11.15 17.0063 11.6 17.0063 12.15Z" :fill="fill"/>
  </svg>
</template>

<script>
  export default {
    name: "editIcon",
    props: {
      fill: {
        type: String,
        default: '#109CF1'
      }
    }
  }
</script>
